module.exports = __webpack_public_path__ + "static/media/core_4.b5431f3f.png";